import React from "react"
import styled from "styled-components"
import Card from "./card"

const CardGroupStyled = styled.div`
  > div {
    padding: 0.5rem 0;
    border-bottom: 1px solid #555;
  }
  > div:last-of-type {
    border-bottom: none;
  }
  @media screen and (min-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > div {
      border-bottom: none;
      padding: 0 0.5rem;
    }
  }
`

const Link = styled.a`
  text-decoration: none;
  :hover {
    text-decoration: none;
  }
`

const CardGroup = ({ productData }) => {
  return (
    <Link
      href="https://www.nike.com/id/en_gb/c/women"
      target="_blank"
      rel="noopener noreferrer"
    >
      <CardGroupStyled>
        {productData.map((product, index) => {
          return <Card key={index} src={product.node.largeImageURL} />
        })}
      </CardGroupStyled>
    </Link>
  )
}

export default CardGroup
